/*
 * PaymentDialog Messages
 *
 * This contains all the text for the PaymentDialog component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages<string>({
  title: {
    id: 'app.containers.PaymentDialog.title',
    defaultMessage: 'Payment Details',
  },
  summary: {
    id: 'app.containers.PaymentDialog.summary',
    defaultMessage: 'Summary',
  },
  nextButton: {
    id: 'app.containers.PaymentDialog.nextButton',
    defaultMessage: 'Next',
  },
  backButton: {
    id: 'app.containers.PaymentDialog.backButton',
    defaultMessage: 'Back',
  },
  cancelButton: {
    id: 'app.containers.PaymentDialog.cancelButton',
    defaultMessage: 'Cancel',
  },
  submitButton: {
    id: 'app.containers.PaymentDialog.submitButton',
    defaultMessage: 'Submit',
  },
  billingCycle1: {
    id: 'app.containers.PaymentDialog.perMonth',
    defaultMessage: '/mo',
  },
  billingCycle12: {
    id: 'app.containers.PaymentDialog.perYear',
    defaultMessage: '/yr',
  },
  paypalTitle: {
    id: 'app.containers.PaymentDialog.paypalTitle',
    defaultMessage: 'PayPal Payment',
  },
  paypalDescription: {
    id: 'app.containers.PaymentDialog.paypalDescription',
    defaultMessage:
      "Click the PayPal button below to pay securely. You'll be redirected to PayPal to complete your payment.",
  },
  paypalInitializing: {
    id: 'app.containers.PaymentDialog.paypalInitializing',
    defaultMessage: 'Initializing PayPal...',
  },
  paypalProcessing: {
    id: 'app.containers.PaymentDialog.paypalProcessing',
    defaultMessage: 'Processing...',
  },
  paypalInitialize: {
    id: 'app.containers.PaymentDialog.paypalInitialize',
    defaultMessage: 'Initialize PayPal',
  },
  paypalNotAvailable: {
    id: 'app.containers.PaymentDialog.paypalNotAvailable',
    defaultMessage: 'PayPal is not available. Please try again or contact support.',
  },
});
